<template>
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="资产码">
        <el-input placeholder="请输入资产码" v-model="filter.assets_code" clearable></el-input>
      </el-form-item>
      <el-form-item label="名称">
        <el-input placeholder="请输入名称" v-model="filter.name" clearable></el-input>
      </el-form-item>
      <el-form-item label="是否投运">
        <el-select class="selScale" v-model="filter.is_operation">
          <el-option label="--全部--" value=""> </el-option>
          <el-option label="是" value="true"> </el-option>
          <el-option label="否" value="false"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
        <el-button icon="el-icon-plus" type="success" @click="onAdd" v-permision_tjtf="'add'">{{ $t("publics.add") }}</el-button>
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="序号" type="index" width="80"></el-table-column>
      <el-table-column label="台区名称" prop="name" width="220"></el-table-column>
      <el-table-column label="是否投运" prop="status_name" align="center" width="100">
        <template slot-scope="{ row }">
          <el-tag type="success" v-if="row.is_operation">是</el-tag>
          <el-tag type="info" v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="资产码" prop="assets_code" width="220" align="center">
        <template slot-scope="{ row }">
          <div class="show_assets_code" @click="showTripletDetail(row.assets_code)">{{ row.assets_code }}</div>
        </template>
      </el-table-column>
      <el-table-column label="所属站点" prop="site_name"></el-table-column>
      <!-- 新增GPS纬度、经度列 -->
      <el-table-column label="GPS纬度" prop="gps_lat" width="120"></el-table-column>
      <el-table-column label="GPS经度" prop="gps_lng" width="120"></el-table-column>

      <el-table-column label="台区图片" prop="pic_json">
        <template slot-scope="{ row }">
          <el-image v-if="getFirstImageUrl(row.pic_json)" class="table-img" :src="getFirstImageUrl(row.pic_json)" fit="cover" :preview-src-list="getAllImageUrls(row.pic_json)"> </el-image>
          <span v-else>无图片</span>
        </template>
      </el-table-column>

      <el-table-column label="创建时间" prop="create_time"></el-table-column>
      <el-table-column label="修改时间" prop="modify_time"></el-table-column>
      <el-table-column :label="$t('publics.operation')" width="140px">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onUpdate(row)" v-permision_tjtf="'edit'">编辑</el-button>
          <el-button type="text" v-if="row.triplet_id > 0" @click="onConfig(row)" v-permision_tjtf="'‌configure'">配置</el-button>
          <el-button type="text" @click="onDelete(row)" v-permision_tjtf="'delete'">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <!-- 新增or修改变压器 -->
    <el-dialog :visible.sync="visible.editGroup" :title="isUpdate ? $t('groupmanage.editortitle') : $t('groupmanage.appendtitle')" width="1000px">
      <el-row type="flex" justify="center">
        <el-col :span="20">
          <el-form label-position="right" label-width="100px" :model="form" :rules="formRules" ref="groupForm">
            <el-form-item label="台区名称" prop="name" label-width="20%">
              <el-input placeholder="请输入台区名称" v-model="form.name" maxlength="30" show-word-limit />
            </el-form-item>
            <el-form-item label="三元组" prop="assets_code" label-width="20%">
              <div @click="onSelectTriplet">
                <el-input style="width: 380px" :disabled="isUpdate" v-model="form.assets_code" readonly placeholder="请选择三元组" suffix-icon="el-icon-more"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="所属站点" prop="power_site_id" label-width="20%">
              <el-select v-model="form.power_site_id" placeholder="请选择所属站点" style="width: 100%" clearable filterable @change="handleSiteChange">
                <el-option v-for="item in siteOptions" :key="item.ID" :label="item.name" :value="item.ID">
                  <span style="float: left">{{ item.name }}</span>
                  <!-- <span style="float: right; color: #8492a6; font-size: 13px">
                    {{ item.address }}
                  </span> -->
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 新增GPS纬度、经度表单项 -->
            <el-form-item label="GPS纬度" prop="gps_lat" label-width="20%">
              <el-input placeholder="请输入GPS纬度（例：39.908823）" v-model.number="form.gps_lat" type="number" step="0.000001" min="-90" max="90" />
            </el-form-item>
            <el-form-item label="GPS经度" prop="gps_lng" label-width="20%">
              <el-input placeholder="请输入GPS经度（例：116.397470）" v-model.number="form.gps_lng" type="number" step="0.000001" min="-180" max="180" />
            </el-form-item>
            <el-form-item label="是否投运" label-width="20%">
              <el-switch v-model="form.is_operation" active-text="是" inactive-text="否" />
            </el-form-item>
            <el-form-item label="台区图片" prop="pic_json" label-width="20%">
              <file-upload listType="picture-card" :limit="100" @fileChange="fileChange" field="pic_json" :fileList="form.pic_json"></file-upload>
            </el-form-item>
            <el-form-item label="备注" prop="remark" label-width="20%">
              <el-input placeholder="请输入备注" v-model="form.remark" />
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button @click="visible.editGroup = false">{{ $t("groupmanage.cancelbtn") }}</el-button>
        <el-button type="primary" @click="onSubmit">{{ $t("groupmanage.confirmbtn") }}</el-button>
      </span>
    </el-dialog>

    <!-- 配置电柜对话框 -->
    <el-dialog :visible.sync="visible.configDialog" title="配置更新" width="600px">
      <el-row type="flex" justify="center">
        <el-col :span="22">
          <el-form label-position="right" label-width="200px" :model="configForm" :rules="configRules" ref="configForm">
            <!-- 终端上报频率（实时监测上报频率） - 增加不允许输入小数点校验 -->
            <el-form-item label="终端上报频率(秒)：" prop="triphase_freq" required>
              <el-input-number v-model="configForm.triphase_freq" :min="1" :max="86400" :step="1" :precision="0" placeholder="请输入终端上报频率" style="width: 200px" />
            </el-form-item>

            <!-- 负荷开关属性上报频率 - 增加不允许输入小数点校验 -->
            <el-form-item label="负荷开关属性上报频率(秒)：" prop="breaker_freq" required>
              <el-input-number v-model="configForm.breaker_freq" :min="1" :max="86400" :step="1" :precision="0" placeholder="请输入负荷开关属性上报频率" style="width: 200px" />
            </el-form-item>

            <!-- A相负荷容量 - 增加不允许输入小数点校验 -->
            <el-form-item label="A相负荷容量(kWA)：" prop="trans_acap" required>
              <el-input-number v-model="configForm.trans_acap" :min="0" :max="10000" :step="1" :precision="0" placeholder="请输入A相负荷容量" style="width: 200px" />
            </el-form-item>

            <!-- B相负荷容量 - 增加不允许输入小数点校验 -->
            <el-form-item label="B相负荷容量(kWA)：" prop="trans_bcap" required>
              <el-input-number v-model="configForm.trans_bcap" :min="0" :max="10000" :step="1" :precision="0" placeholder="请输入B相负荷容量" style="width: 200px" />
            </el-form-item>

            <!-- C相负荷容量 - 增加不允许输入小数点校验 -->
            <el-form-item label="C相负荷容量(kWA)：" prop="trans_ccap" required>
              <el-input-number v-model="configForm.trans_ccap" :min="0" :max="10000" :step="1" :precision="0" placeholder="请输入C相负荷容量" style="width: 200px" />
            </el-form-item>

            <!-- 负荷开关A（隐藏字段，同样加上precision） -->
            <el-form-item label="负荷开关A：" prop="breaker_a" v-if="false" required>
              <el-radio-group v-model="configForm.breaker_a">
                <el-radio :label="0">无</el-radio>
                <el-radio :label="1">合闸</el-radio>
                <el-radio :label="2">跳闸</el-radio>
              </el-radio-group>
            </el-form-item>

            <!-- 负荷开关B（隐藏字段） -->
            <el-form-item label="负荷开关B：" prop="breaker_b" v-if="false" required>
              <el-radio-group v-model="configForm.breaker_b">
                <el-radio :label="0">无</el-radio>
                <el-radio :label="1">合闸</el-radio>
                <el-radio :label="2">跳闸</el-radio>
              </el-radio-group>
            </el-form-item>

            <!-- 负荷开关C（隐藏字段） -->
            <el-form-item label="负荷开关C：" prop="breaker_c" v-if="false" required>
              <el-radio-group v-model="configForm.breaker_c">
                <el-radio :label="0">无</el-radio>
                <el-radio :label="1">合闸</el-radio>
                <el-radio :label="2">跳闸</el-radio>
              </el-radio-group>
            </el-form-item>

            <!-- 下发结果和下发时间 -->
            <el-form-item label="下发结果：" v-if="configForm && configForm.send_log">
              <span :style="{ color: configForm.send_log.push_state == 1 ? '#67C23A' : '#F56C6C' }"> {{ configForm.send_log.push_state == 0 ? "未下发" : configForm.send_log.push_state == 1 ? "成功" : "失败" }} </span><br />
              <span :style="{ color: configForm.send_log.push_state == 1 ? '#67C23A' : '#F56C6C' }">
                {{ configForm.send_log.remark }}
              </span>
              <br />
              <span :style="{ color: configForm.send_log.push_state == 1 ? '#67C23A' : '#F56C6C' }"> 操作时间：{{ configForm.send_log.push_time }} </span>
              <br />
              <span :style="{ color: configForm.send_log.push_state == 1 ? '#67C23A' : '#F56C6C' }"> 实发时间：{{ configForm.send_log.run_time }} </span>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button @click="visible.configDialog = false">取消</el-button>
        <el-button type="primary" @click="saveParamSubmit(1)">保存配置</el-button>
        <el-button type="success" @click="saveParamSubmit(2)">下发配置</el-button>
      </span>
    </el-dialog>

    <!-- 三元组选择框 -->
    <select-triplet :show.sync="visible.triplet" @confirm="confirmSelectTriplet" :device-type="form.typename"></select-triplet>
    <tripletDetail ref="tripletDetail"></tripletDetail>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import fileUpload from "@/components/fileUpload/fileUpload.vue"
import selectTriplet from "./components/select-triplet.vue"
import tripletDetail from "../control/_triplet_detail.vue"
import { getPowerTransformerList, modifyPowerTransformer, delPowerTransformer, addPowerTransformer, getPowerSiteList, GetSetParamByTransformerId, SaveSetParam, PushSetParam } from "@/api/dev_archive"
import { mapGetters } from "vuex"
export default {
  name: "GroupManage",
  mixins: [pageMixin],
  components: { fileUpload, selectTriplet, tripletDetail },
  data() {
    return {
      visible: {
        editGroup: false,
        triplet: false,
        configDialog: false
      },
      tableData: [],
      form: {
        name: "",
        power_site_id: "",
        remark: "",
        triplet_id: "",
        assets_code: "",
        typename: "台区",
        gps_lat: 0,
        gps_lng: 0,
        is_operation: true,
        pic_json: []
      },
      siteOptions: [],
      formRules: {},
      configRules: {},
      filter: {
        name: "",
        assets_code: "",
        is_operation: ""
      },
      loading: false,
      isUpdate: true,
      gid: "",
      configForm: {
        triphase_freq: 300,
        breaker_freq: 300,
        trans_acap: 0,
        trans_bcap: 0,
        trans_ccap: 0,
        breaker_a: 0,
        breaker_b: 0,
        breaker_c: 0
      },
      currentCabinetId: "",
      currentCabinetName: "",
      configResult: null,
      isConfigLoading: false,
      uploadhandlerimgs: "",
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    this.formRules = {
      power_site_id: [{ required: true, message: "请选择所属站点", trigger: "change" }],
      assets_code: [{ required: true, message: "请选择三元信息", trigger: "change" }],
      name: [{ required: true, message: "请输入台区名称", trigger: "change" }],
      gps_lat: [
        {
          type: "number",
          pattern: /^-?\d+(\.\d{1,6})?$/,
          message: "纬度必须为数字，且最多保留6位小数",
          trigger: "blur"
        },
        {
          type: "number",
          min: -90,
          max: 90,
          message: "纬度范围为-90至90",
          trigger: "blur"
        }
      ],
      gps_lng: [
        {
          type: "number",
          pattern: /^-?\d+(\.\d{1,6})?$/,
          message: "经度必须为数字，且最多保留6位小数",
          trigger: "blur"
        },
        {
          type: "number",
          min: -180,
          max: 180,
          message: "经度范围为-180至180",
          trigger: "blur"
        }
      ]
    }
    this.configRules = {}
    this.loadSiteOptions().then(() => {
      this.getData()
    })
  },
  methods: {
    showTripletDetail(assetsCode) {
      this.$refs.tripletDetail.showTripletInfo(assetsCode)
    },
    loadSiteOptions() {
      return getPowerSiteList({
        pagesize: 100000
      }).then((res) => {
        if (res && res.data) {
          this.siteOptions = res.data.filter((item) => !item.del)
          return this.siteOptions
        }
        return []
      })
    },
    handleSiteChange(value) {
      if (value) {
        const selectedSite = this.siteOptions.find((item) => item.ID === value)
      }
    },
    async saveParamSubmit(type) {
      this.$refs.configForm.validate(async (valid) => {
        if (!valid) {
          this.$message.warning("请检查表单填写是否正确")
          return
        }
        const loading = this.$loading({
          lock: true,
          text: "正在保存配置...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        })
        const saveData = {
          bmi_power_transformer_id: this.currentCabinetId,
          ...this.configForm
        }
        let result = null
        if (type == 1) {
          result = await SaveSetParam(saveData)
        } else {
          result = await PushSetParam(saveData)
        }
        loading.close()
        if (result && result.status) {
          this.$message.success(result.msg)
          this.visible.configDialog = false
          this.configResult = null
        } else {
          this.$message.error(result?.msg || "配置保存失败")
        }
      })
    },
    async onConfig(row) {
      this.currentCabinetId = row.ID
      this.currentCabinetName = row.name
      this.configResult = null
      this.isConfigLoading = true
      GetSetParamByTransformerId({
        TransformerId: row.ID
      }).then((res) => {
        if (res && res.data) {
          const data = res.data
          this.configForm = res.data
          this.isConfigLoading = false
          this.configForm.triplet_id = row.triplet_id
        } else {
          this.configForm = this.getDefaultConfig()
          this.$message.info("该设备暂无配置，将使用默认值")
        }
      })
      this.isConfigLoading = false
      this.visible.configDialog = true
    },
    getDefaultConfig() {
      return {
        triphase_freq: 300,
        breaker_freq: 300,
        trans_acap: 0,
        trans_bcap: 0,
        trans_ccap: 0,
        breaker_a: 60,
        breaker_b: 60,
        breaker_c: 60
      }
    },
    async onUpdate(row) {
      this.visible.editGroup = true
      this.isUpdate = true
      if (!this.siteOptions.length) {
        await this.loadSiteOptions()
      }
      this.form.name = row.name
      this.form.power_site_id = row.power_site_id
      this.form.remark = row.remark
      this.gid = row.ID
      this.form.triplet_id = row.triplet_id
      this.form.assets_code = row.assets_code
      this.form.gps_lat = row.gps_lat || 0
      this.form.gps_lng = row.gps_lng || 0
      this.form.is_operation = row.is_operation

      if (row.pic_json) {
        try {
          if (row.pic_json.startsWith("[") || row.pic_json.startsWith("{")) {
            const picArray = JSON.parse(row.pic_json)
            if (Array.isArray(picArray)) {
              this.form.pic_json = picArray.map((item) => ({
                ...item,
                url: item.path,
                name: item.name || `image_${item.id || Date.now()}`,
                path: item.path,
                size: item.size || 0
              }))
            } else {
              this.form.pic_json = []
            }
          } else {
            const urls = row.pic_json
              .replace(/^,|,$/g, "")
              .split(",")
              .filter((url) => url.trim() !== "")
            this.form.pic_json = urls.map((url, index) => ({
              url: url.trim(),
              name: `image_${index + 1}`,
              path: url.trim(),
              size: 0
            }))
          }
        } catch (error) {
          const urls = row.pic_json
            .replace(/^,|,$/g, "")
            .split(",")
            .filter((url) => url.trim() !== "")
          this.form.pic_json = urls.map((url, index) => ({
            url: url.trim(),
            name: `image_${index + 1}`,
            path: url.trim(),
            size: 0
          }))
        }
      } else {
        this.form.pic_json = []
      }

    },
    fileChange(fileList, field) {
      this.uploadhandlerimgs = ""
      this.form[field] = fileList
      fileList.forEach((d) => {
        this.uploadhandlerimgs += d.url + ","
      })
    },
    onDelete(row) {
      this.$confirm("确定要删除该台区吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        delPowerTransformer(row).then((res) => {
          this.$message.success(`删除成功`)
          this.toFilter()
        })
      })
    },
    confirmSelectTriplet(item) {
      this.visible.triplet = false
      this.form.triplet_id = item.ID
      this.form.assets_code = item.assetsCode
    },
    onSelectTriplet() {
      if (this.isUpdate) {
        return
      }
      this.visible.triplet = true
    },
    getData() {
      this.loading = true
      getPowerTransformerList({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        ...this.filter
      })
        .then((res) => {
          const siteMap = {}
          this.siteOptions.forEach((site) => {
            siteMap[site.ID] = site.name
          })
          this.tableData = res.data.map((item) => {
            return {
              ...item,
              site_name: siteMap[item.power_site_id] || item.power_site_id
            }
          })
          this.pageParams.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    async onAdd() {
      this.visible.editGroup = true
      this.isUpdate = false
      this.form = this.$options.data().form
      if (!this.siteOptions.length) {
        await this.loadSiteOptions()
      }
    },
    onSubmit() {
      this.$refs.groupForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading()
          const reqData = {
            triplet_id: this.form.triplet_id,
            name: this.form.name,
            power_site_id: this.form.power_site_id,
            remark: this.form.remark,
            gps_lat: this.form.gps_lat,
            gps_lng: this.form.gps_lng,
            is_operation: this.form.is_operation,
            pic_json: this.uploadhandlerimgs
          }
          console.log("提交的数据:", reqData)
          if (this.isUpdate) {
            reqData.ID = this.gid
            modifyPowerTransformer(reqData)
              .then((res) => {
                this.$message.success(res.msg)
                this.visible.editGroup = false
                this.toFilter()
              })
              .finally(() => {
                loading.close()
              })
          } else {
            addPowerTransformer(reqData)
              .then((res) => {
                this.$message.success(`${this.$t("publics.addedsuccessful")}`)
                this.visible.editGroup = false
                this.toFilter()
              })
              .finally(() => {
                loading.close()
              })
          }
        }
      })
    },

    getFirstImageUrl(picJsonString) {
      if (!picJsonString) return null

      try {
        if (picJsonString.startsWith("[") || picJsonString.startsWith("{")) {
          const picArray = JSON.parse(picJsonString)
          if (Array.isArray(picArray)) {
            const validPics = picArray.filter((pic) => pic.path && pic.path.trim() !== "")
            if (validPics.length > 0) {
              return validPics[0].path
            }
          }
        } else {
          const urls = picJsonString
            .replace(/^,|,$/g, "")
            .split(",")
            .filter((url) => url.trim() !== "")
          if (urls.length > 0) {
            return urls[0].trim()
          }
        }
        return null
      } catch (error) {
        const urls = picJsonString
          .replace(/^,|,$/g, "")
          .split(",")
          .filter((url) => url.trim() !== "")
        if (urls.length > 0) {
          return urls[0].trim()
        }
        return null
      }
    },

    getAllImageUrls(picJsonString) {
      if (!picJsonString) return []

      try {
        if (picJsonString.startsWith("[") || picJsonString.startsWith("{")) {
          const picArray = JSON.parse(picJsonString)
          if (Array.isArray(picArray)) {
            return picArray.filter((pic) => pic.path && pic.path.trim() !== "").map((pic) => pic.path)
          }
        } else {
          const urls = picJsonString
            .replace(/^,|,$/g, "")
            .split(",")
            .filter((url) => url.trim() !== "")
          return urls.map((url) => url.trim())
        }
        return []
      } catch (error) {
        const urls = picJsonString
          .replace(/^,|,$/g, "")
          .split(",")
          .filter((url) => url.trim() !== "")
        return urls.map((url) => url.trim())
      }
    },

  }
}
</script>

<style scoped>
.p-20 {
  padding: 20px;
}

.table-img {
  width: 50px;
  height: 50px;
}
</style>
